import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../../../core/modules/shared.module';
import { ReversarCierreMes} from './ReversarCierreMes.component';
import { RoleGuardService as RoleGuard } from './../Seguridad/role-guard.service';


const routes = [
    {
        path     : 'ReversarCierreMes',
        component: ReversarCierreMes,
        canActivate: [RoleGuard], 
        data: { 
          formulario: 'ReversarCierreMes'
        } 
    }
];

@NgModule({
    declarations: [
        ReversarCierreMes
    ],
    imports     : [
        SharedModule,
        RouterModule.forChild(routes)
    ],
    exports     : [
        ReversarCierreMes
    ],
    bootstrap: [ReversarCierreMes]
})

export class ReversarCierreMesModule
{
}




// WEBPACK FOOTER //
// D:/Repositorios/FacturacionWeb/src/app/main/content/ReversarCierreMes/ReversarCierreMes.module.ts